import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/ViewAnnouncements.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Components/Loader";

function FacultyViewAnnouncements() {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchAnnouncements = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                const response = await axios.get(
                    "https://api.uniums.com/api/announcement/view-announcements-for-user",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                setAnnouncements(response.data.data);
                toast.success("Announcements fetched successfully!");
            } catch (error) {
                console.error("Error fetching announcements:", error);
                toast.error("Failed to fetch announcements.");
            } finally {
                setLoading(false);
            }
        };

        fetchAnnouncements();
    }, []);

    return (
        <>
            <div className="view-announcements">
                <h1>View Announcements</h1>
                {loading && <Loader />}
                <div className="announcements-grid">
                    {announcements.length > 0 ? (
                        announcements.map((announcement) => (
                            <div
                                key={announcement._id}
                                className={`announcements-card ${announcement.isCancelled ? "highlighted" : ""}`}
                            >
                                <h2>{announcement.title}</h2>
                                <p>
                                    <strong>Date:</strong> {new Date(announcement.date).toLocaleDateString()}
                                </p>
                                {announcement.time && (
                                    <p>
                                        <strong>Time:</strong> {announcement.time}
                                    </p>
                                )}
                                <p>
                                    <strong>Type:</strong> {announcement.type}
                                </p>
                                <p>
                                    <strong>Audience:</strong> {announcement.audience}
                                </p>
                                <p>
                                    <strong>Location:</strong> {announcement.location}
                                </p>
                                <p>{announcement.description}</p>
                                {announcement.attachment && (
                                    <p>
                                        <strong>Attachment:</strong> <a href={announcement.attachment} target="_blank" rel="noopener noreferrer">View Attachment</a>
                                    </p>
                                )}
                                {announcement.remark && (
                                    <p>
                                        <strong>Remark:</strong> {announcement.remark}
                                    </p>
                                )}
                            </div>
                        ))
                    ) : (
                        <p>No upcoming announcements found.</p>
                    )}
                </div>
            </div>
            <ToastContainer />
        </>

    );
}

export default FacultyViewAnnouncements;
